import { displayError } from '../helpers';
import { printPurchaseCreditNote } from '../services/PurchaseCreditNoteServices';
import { openPdfInApp } from './openPdfInApp';

async function parseApiError(error) {
    const responseData = error?.response?.data;
    if (responseData instanceof Blob) {
        try {
            const text = await responseData.text();
            try {
                return JSON.parse(text);
            } catch (parseError) {
                return { message: text || 'Failed to generate purchase credit note PDF.' };
            }
        } catch (readError) {
            return { message: 'Failed to generate purchase credit note PDF.' };
        }
    }
    return responseData || error;
}

export function fetchAndShowPurchaseCreditNotePdf(cookies, noteId, options = {}) {
    return printPurchaseCreditNote(cookies, noteId)
        .then((pdfResponse) => {
            openPdfInApp(pdfResponse, {
                title: options.title || 'Purchase Credit Note PDF',
                onClose: options.onClose,
            });
        })
        .catch(async (error) => {
            const parsedError = await parseApiError(error);
            displayError(parsedError || { message: 'Failed to generate purchase credit note PDF.' }, options.errorTitle || 'Print Failed');
        });
}
